import styled, { css } from 'styled-components';
import { hideScroll } from 'styled-manila';
import { getColor, StyleVars, typeScale } from 'core/utils';
import Heading from 'core/components/Heading';
import LazyLoadedImg from 'core/components/LazyLoadedImg';

const cardMinWidth = size => css`
	width: ${size};
	flex-basis: ${size};
	max-width: ${size};
	min-width: ${size};
`;

export const Wrapper = styled.section`
	padding: 16px 0;

	@media (max-width: ${StyleVars.screenSm}) {
		padding: ${typeScale(1)};
	}
`;

export const PastBoxHeading = styled(Heading)`
	margin: 0;
`;

export const Boxes = styled.div`
	display: flex;
	flex-wrap: nowrap;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	margin-left: -12px;
	margin-right: -12px;
	${hideScroll};
	scrollbar-width: none;

	padding-top: 16px;
	padding-bottom: 16px;
	padding-left: 16px;

	${props => props.$compact && css`
		padding-top: 16px;
		padding-bottom: 0px;
	`}

	@media(max-width: ${StyleVars.screenMd}) {
		padding-top: ${typeScale(1)};
		padding-bottom: 0px;
		margin-left: -16px;
		margin-right: -16px;
		padding-left: 25px;
	}
`;

export const Box = styled.a`
	display: flex;
	flex-direction: column;
	text-decoration: none;
	padding: 0 12px;
	margin-bottom: 0;
	${cardMinWidth("33%")}

	@media(max-width: ${StyleVars.screenMd}) {
		${cardMinWidth("267px")}

		/* Show the last gap to the right */
		&:last-child {
			position: relative;

			&:after {
				content: '';
				width: 32px;
				height: 100%;
				display: block;
				position: absolute;
				top: 0;
				right: -32px;
			}
		}

	}
	cursor: pointer;
	figure {
		border-radius: 8px;
		margin-bottom: 17px;
		background-color: ${getColor('alto')};
	}
`;

export const Frame = styled.div`
	overflow: hidden;
	position: relative;
	padding-top: 100%;
	border-radius: 8px;
`;

export const PastBoxImage = styled(LazyLoadedImg)`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const Title = styled.h4`
	color: ${getColor("gray")};
	margin-bottom: 5px;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	font-weight: 600;

	@media(max-width: ${StyleVars.screenMd}) {
		margin-top: 0;
	}
`;

export const Description = styled.p`
	color: ${getColor('dustyGray')};
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.2px;
`;

export const BoxesWrapper = styled.div`
	overflow: hidden;
	position: relative;
	width: 100%;
	margin-top: 24px;

	@media(max-width: ${StyleVars.screenMd}) {
		margin-left: -12px;
	}

	@media(max-width: ${StyleVars.screenSm}) {
		margin-top: ${typeScale(1)};
	}

	${props => props.$compact && css`
		margin-top: 4px;
	`}

`;
